import React from 'react';
import { syncArticles, syncArticle, syncArticleMetafields, saveArticles, createArticleCustomContents, deleteArticleCustomContent, exportArticles, importArticles, clearExportUrls, resetErrors } from '../../modules/articles'
import withRouter from 'with-router'
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import ItemsList from '../../components/ItemsList'
import ItemsListSkeleton from '../../components/ItemsListSkeleton'
import LoadingIndicator from '../../components/LoadingIndicator';
import EmptyView from '../../components/EmptyView';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import OptionsMenu from '../../components/OptionsMenu';
import NewFlexItemList from '../../components/NewFlexItemList';
import cloneDeep from 'lodash/cloneDeep';
import LinkElement from '@mui/material/Link';
import { Trans, withTranslation, useTranslation } from 'react-i18next';
import ExportImportDialogs from '../../components/ExportImportDialogs';
import { _clearUnchangedFields } from '../../helper';
import API from '../../api/api';


class Articles extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      data: [],
      addingNewCustomContent: false,
      addingNewCustomContentArticleId: null,
      customContentPlainTextData: [],
      showDownloadDialog: true,
      showImportCompleteDialog: false,
      errorLockCollapse: false,
      forceOpenExportDialog: false,
      forceOpenImportDialog: false,
    }
  }

  componentDidMount() {
    this.props.syncArticles(this.props.editLanguage)
    if(this.props.articles.export_po_download_url || this.props.articles.export_csv_download_url) {
      this.setState({showDownloadDialog: false})
    }
  }

  componentWillUnmount() {
    API.clearAllFetches();
  }

  getErrorsFor(key, item) {
    if (typeof item.errors === 'undefined') return false;
    let error = item.errors.find(x => x.object_key === key);
    return error;
  }

  componentWillReceiveProps(newProps) {
    const { t } = this.props;
    const currentLanguage = this.props.editLanguage;
    const newLanguage = newProps.editLanguage;
    if(currentLanguage != newLanguage) {
      this.props.syncArticles(newLanguage)
      return
    }

    if(this.props.articles.import_articles_pending === true && newProps.articles.import_articles_pending === false && !newProps.articles.error && !newProps.articles.import_cancelled) {
      this.setState({showImportCompleteDialog: true}, () => {
        this.setState({showImportCompleteDialog: false});
      })
    }

    if((this.props.articles.sync_article_pending === true && newProps.articles.sync_article_pending === false) || (this.props.articles.save_articles_pending === true && newProps.articles.save_articles_pending === false) || (this.props.articles.sync_articles_pending === true && newProps.articles.sync_articles_pending === false)) {
      const newData = [];

      newProps.articles.articles.forEach(item => {
        let customFields = []

        if(item.custom_contents) {
          item.custom_contents.forEach(custom_content => {
            customFields.push({
              id: custom_content.id,
              type: 'text',
              deletable: true,
              multiline: true,
              rows: 7,
              source: custom_content.source.text,
              target: custom_content.target.text
            })
          })
        }

        let currentMetafields = null;
        if(!(this.props.articles.sync_articles_pending === true && newProps.articles.sync_articles_pending === false)) {
          const currentArticle = this.state.data.find(x => x.id == item.id);
          if(currentArticle) {
            currentMetafields = currentArticle.fields.find(x => x.id === 'metafields');
          }
        }

        let seoFields = []

        if(typeof item.target.page_title !== 'undefined') {
          seoFields.push({
            id: 'page_title',
            type: 'text',
            label: 'SEO Title',
            source: item.source.page_title || '',
            target: item.target.page_title || '',
            customized: item.customSeo.meta_title,
            maxLength: 255,
          })
        }

        if(typeof item.target.page_description !== 'undefined') {
          seoFields.push({
            multiline: true,
            rows: 6,
            id: 'page_description',
            type: 'text',
            label: 'SEO Description',
            source: item.source.page_description || '',
            target: item.target.page_description || '',
            customized: item.customSeo.meta_description,
            maxLength: 500,
          })
        }

        let imageFields = [];
        if(item.source.image) {
          const hasAlt = !!(item.source.article_image && item.source.article_image.alt);
          imageFields.push({
            id: 'image',
            type: 'image',
            hasAlt: hasAlt,
            source: item.source.image ? item.source.image.src : '',
            target: item.target.image ? item.target.image.src : ''
          });
          // the article image's alt rides along as a paired text field, like product image alts
          if(hasAlt) {
            imageFields.push({
              id: 'image-alt',
              imageId: 'image',
              type: 'text',
              multiline: true,
              autoGrow: true,
              maxLength: 512,
              label: this.props.t('imageField.altLabel'),
              source: item.source.article_image.alt,
              target: (item.target.article_image && item.target.article_image.alt) ? item.target.article_image.alt : ''
            });
          }
        }

        newData.push({
          type: 'article',
          id: item.id,
          shopify_id: item.shopifyId,
          progress: item.progress,
          synchronized: item.synchronized,
          metafields_synchronized: item.metafields_synchronized,
          title: item.source.title,
          info: '',
          fields: [{
            id: 'title',
            type: 'text',
            label: 'Title',
            source: item.source.title,
            target: item.target.title || ''
          },
          {
            multiline: true,
            rows: 10,
            id: 'body_html',
            type: 'richtext',
            label: 'Description',
            source: item.source.body_html || '',
            target: item.target.body_html || '',
          },
          {
            multiline: true,
            rows: 10,
            id: 'summary_html',
            type: 'richtext',
            label: 'Summary',
            source: item.source.summary_html || '',
            target: item.target.summary_html || '',
          },
          {
            id: 'handle',
            type: 'text',
            label: 'Handle',
            source: item.source.handle,
            target: item.target.handle || '',
            errors: this.getErrorsFor('handle', item) || false
          },
          {
            id: 'seofields',
            type: 'subfields',
            fields: seoFields
          },
          {
            id: 'images',
            type: 'subfields',
            fields: imageFields
          },
          {
            id: 'metafields',
            type: 'subfields',
            fields: currentMetafields ? cloneDeep(currentMetafields.fields) : []
          },
          {
            id: 'customfields',
            onAddItem: this.openNewCustomContentDialog,
            onDeleteItem: this.onDeleteCustomContent(item.id),
            emptyMessage: <EmptyView 
              title={t('customContents.noCustomContentInSection')}
              description={t('customContents.info1')}
              bottom={<Button variant="outlined" size="small" onClick={e => {this.openNewCustomContentDialog(item.id)}}>{t('customContents.addNewCustomContent')}</Button>}
              dense={true} 
            />,
            type: 'subfields',
            fields: customFields
          }]
        })
      })

      this.setState({data:newData});
    }

    if(this.props.articles.sync_article_metafields_pending === true && newProps.articles.sync_article_metafields_pending === false) {
      let newData = cloneDeep(this.state.data);
      newProps.articles.articles.forEach(article => {
        if(article.metafields) {
            let articleToUpdate = newData.find(x => x.id == article.id)

            let newMetafields = []
            article.metafields.forEach(metafield => {
              const currentField = articleToUpdate.fields.find(x => x.id === 'metafields').fields.find(x => x.id == metafield.id);
              if(!currentField) {
                newMetafields.push({
                  id: metafield.id,
                  type: 'text',
                  multiline: true,
                  rows: 7,
                  source: metafield.source,
                  target: metafield.target || '',
                  label: metafield.namespace + ' -> ' + metafield.key
                })
              } else {
                if(article.metafields.find(x => x.id === currentField.id)) {
                  newMetafields.push({...currentField});
                }
              }
            })

            articleToUpdate.metafields_synchronized = article.metafields_synchronized
            articleToUpdate.fields.find(x => x.id === 'metafields').fields = newMetafields
        }
      })

      this.setState({data:newData});
    }

    if((this.props.articles.create_article_custom_contents_pending === true && newProps.articles.create_article_custom_contents_pending === false) || (this.props.articles.delete_article_custom_content_pending === true && newProps.articles.delete_article_custom_content_pending === false)) {
      let newData = cloneDeep(this.state.data);
      newProps.articles.articles.forEach(article => {
        if(article.custom_contents) {
            let articleToUpdate = newData.find(x => x.id == article.id)

            let newCustomContents = []
            article.custom_contents.forEach(custom_content => {
              const currentField = articleToUpdate.fields.find(x => x.id === 'customfields').fields.find(x => x.id == custom_content.id);
              if(!currentField) {
                newCustomContents.push({
                  id: custom_content.id,
                  type: 'text',
                  deletable: true,
                  multiline: true,
                  rows: 7,
                  source: custom_content.source.text,
                  target: custom_content.target.text
                })
              } else {
                if(article.custom_contents.find(x => x.id === currentField.id)) {
                  newCustomContents.push({...currentField});
                }
              }
            })

            articleToUpdate.custom_contents_synchronized = article.custom_contents_synchronized
            articleToUpdate.fields.find(x => x.id === 'customfields').fields = newCustomContents
        }
      })

      this.setState({data:newData});
    }
  }

  onExpand(id) {
    if(this.state.data.find(x => x.id == id).synchronized !== true) {
      this.props.syncArticle(id, this.props.editLanguage);
    }
  }

  onCollapsed(id) {
    
  }

  onDelete = (selected) => {
  }

  onExpandCollapsableFields = (type, id) => {
    if(type === 'metafields' && this.state.data.find(x => x.id == id).metafields_synchronized != true) {
      this.props.syncArticleMetafields(id, this.props.editLanguage)
    }
  }

  onSave = items => {
    const usedItems = [];
    items.forEach(item => {
      usedItems.push({
        id: item.id,
        title: item.fields.find(x => x.id === 'title').target,
        body_html: item.fields.find(x => x.id === 'body_html').target,
        handle: item.fields.find(x => x.id === 'handle').source == item.fields.find(x => x.id === 'handle').target ? '' : item.fields.find(x => x.id === 'handle').target,
        summary_html: item.fields.find(x => x.id === 'summary_html').target,
        page_title: item.fields.find(x => x.id === 'seofields').fields.find(x => x.id === 'page_title').target,
        page_description: item.fields.find(x => x.id === 'seofields').fields.find(x => x.id === 'page_description').target,
        metafields: item.fields.filter(x => (x.type === 'subfields' && x.id === 'metafields'))[0].fields.map(z => ({ id: z.id, target: z.target })),
        custom_contents: item.fields.filter(x => (x.type === 'subfields' && x.id === 'customfields'))[0].fields.map(z => ({ id: z.id, target: z.target })),
        images: item.fields.filter(x => (x.type === 'subfields' && x.id === 'images'))[0].fields.filter(z => z.type === 'image').map(z => ({ id: z.id, target: z.target })),
        article_image: (() => { const alt = item.fields.filter(x => (x.type === 'subfields' && x.id === 'images'))[0].fields.find(z => z.id === 'image-alt'); return alt ? { alt: alt.target || '' } : undefined; })(),
      });
    })

    this.props.saveArticles(this.props.editLanguage, usedItems)
  }

  onResaveAll = (itemId) => {
    const item = this.state.data.find(x => x.id == itemId);
    if(item) {
      const  usedItems = [{
        id: item.id,
        title: item.fields.find(x => x.id === 'title').target,
        body_html: item.fields.find(x => x.id === 'body_html').target,
        summary_html: item.fields.find(x => x.id === 'summary_html').target,
        page_title: item.fields.find(x => x.id === 'seofields').fields.find(x => x.id === 'page_title').target,
        page_description: item.fields.find(x => x.id === 'seofields').fields.find(x => x.id === 'page_description').target,
        metafields: item.fields.filter(x => (x.type === 'subfields' && x.id === 'metafields'))[0].fields.map(z => ({ id: z.id, target: z.target })),
        custom_contents: item.fields.filter(x => (x.type === 'subfields' && x.id === 'customfields'))[0].fields.map(z => ({ id: z.id, target: z.target })),
        images: item.fields.filter(x => (x.type === 'subfields' && x.id === 'images'))[0].fields.filter(z => z.type === 'image').map(z => ({ id: z.id, target: z.target })),
        article_image: (() => { const alt = item.fields.filter(x => (x.type === 'subfields' && x.id === 'images'))[0].fields.find(z => z.id === 'image-alt'); return alt ? { alt: alt.target || '' } : undefined; })(),
      }]

      this.props.saveArticles(this.props.editLanguage, usedItems, 1)
    }
  }

  openNewCustomContentDialog = (itemId) => {
    const customContentPlainTextData = [];
    const article = this.state.data.find(x => x.id == itemId);

    article.fields.find(x => x.id == 'customfields').fields.forEach((custom_content) => {
      customContentPlainTextData.push(custom_content.source);
    })

    this.setState({addingNewCustomContent: true, addingNewCustomContentArticleId: itemId, customContentPlainTextData: customContentPlainTextData})
  }

  closeNewCustomContentDialog = ()  => {
    this.setState({addingNewCustomContent: false, addingNewCustomContentArticleId: null, customContentPlainTextData: []})
  }

  onSaveNewCustomContentDialog = (articleId, items) => {
    const usedItems = [];
    items.forEach(item => {
      if(item.text != '') {
        usedItems.push({
          text: item.text
        })
      }
    })
    
    this.setState({addingNewCustomContent: false, addingNewCustomContentArticleId: null});
    this.props.createArticleCustomContents(articleId, this.props.editLanguage, usedItems);
  }

  onDeleteCustomContent = articleId => {
    return itemId => {
      this.props.deleteArticleCustomContent(articleId, itemId);
    }
  }

  onImport = (e) => {
    this.setState({forceOpenImportDialog: true}, () => {
      this.setState({forceOpenImportDialog: false});
    });   
    this.setState({ optionsMenuAnchorEl: null });
  }

  onExport = (e) => {
    this.setState({forceOpenExportDialog: true}, () => {
      this.setState({forceOpenExportDialog: false});
    });   
  }

  onCloseDownloadDialog = () => {
    this.setState({showDownloadDialog: false})
  }

  onCloseImportCompleteDialog = () => {
    window.location.reload();
  }

  render() {
    const { t, classes } = this.props

    if(this.props.articles.sync_articles_pending === true || (this.props.articles.error && this.props.articles.error.level === 0)) {
      return <React.Fragment>
        <Typography variant="h4" gutterBottom component="h2">
          {t('pages.articles.title')}
        </Typography>
        <Divider className="divider-white" />
        <ItemsListSkeleton rows="10"/>
        <LoadingIndicator
          pending={this.props.articles.sync_articles_pending || this.props.articles.sync_article_pending || this.props.articles.save_articles_pending || this.props.articles.export_articles_pending}
          progress={this.props.articles.progress}
          error={this.props.articles.error}
        />
      </React.Fragment>  
    }

    return <React.Fragment>
      <Typography variant="h4" gutterBottom component="h2">
        {t('pages.articles.title')}

        <OptionsMenu
          dataTour="page-options-menu"
          onImport={this.onImport}
          onExport={this.onExport}
          shopPlan={this.props.shopPlan}
        />
      </Typography>

      {this.state.addingNewCustomContent ? (
        <NewFlexItemList
          scope={this.state.addingNewCustomContentArticleId}
          data={this.state.customContentPlainTextData}
          onSave={this.onSaveNewCustomContentDialog}
          onCancel={this.closeNewCustomContentDialog}
          isPending={false}
        />
      ) : (
        null
      )}

      <Divider className="divider-white" />

      <ItemsList 
        type="articles"
        pagination={true}
        onExpand={(id) => {this.onExpand(id)}}
        onCollapsed={this.onCollapsed}
        isPending={
          this.props.articles.sync_articles_pending ||
          this.props.articles.sync_article_pending ||
          this.props.articles.sync_article_metafields_pending ||
          this.props.articles.create_article_custom_contents_pending ||
          this.props.articles.delete_article_custom_content_pending ||
          this.props.articles.save_articles_pending ||
          this.props.articles.export_articles_pending ||
          this.props.articles.import_articles_pending
        }
        isSubfieldsPending={
          this.props.articles.create_article_custom_contents_pending ||
          this.props.articles.delete_article_custom_content_pending ||
          this.props.articles.sync_article_metafields_pending
        }
        isSaving={
          this.props.articles.save_articles_pending
        }
        deletable={false}
        onSave={this.onSave}
        onResaveAll={this.onResaveAll}
        data={this.state.data}
        onExpandCollapsableFields={this.onExpandCollapsableFields}
        allowAutoTranslation={true}
        error={this.props.articles.error}
        errorLockCollapse={this.state.errorLockCollapse}
        emptyMessage={
          <EmptyView 
            title={t('pages.articles.noContent')}
            bottom={<Button href={`https://${this.props.shopUrl}/admin/articles`} target="_blank" variant="contained" color="primary">{t('system.createOneHere')}</Button>}
          />
        }
      />
      <LoadingIndicator
        pending={this.props.articles.sync_articles_pending || this.props.articles.sync_article_pending || this.props.articles.sync_article_metafields_pending || this.props.articles.save_articles_pending || this.props.articles.export_articles_pending || this.props.articles.import_articles_pending || this.props.articles.create_article_custom_contents_pending || this.props.articles.delete_article_custom_content_pending}
        loadingType={this.props.articles.save_articles_pending ? 'saving' : 'loading'}
        progress={this.props.articles.progress}
        error={this.props.articles.error}
        onErrorCancel={this.props.resetErrors}
        onErrorRetry={() => {
          this.setState({ errorLockCollapse: true }, () => {
            this.setState({ errorLockCollapse: false });
          });
        }}
      />

      <ExportImportDialogs
        //showDownloadDialog={this.state.showDownloadDialog}
        showImportCompleteDialog={this.state.showImportCompleteDialog}
        imported_entries={this.props.articles.imported_entries}
        export_po_download_url={this.props.articles.export_po_download_url}
        export_csv_download_url={this.props.articles.export_csv_download_url}
        forceOpenExportDialog={this.state.forceOpenExportDialog}
        forceOpenImportDialog={this.state.forceOpenImportDialog}
        exportFunc={(options) => { this.props.exportArticles(this.props.editLanguage, options) }}
        importFunc={(formData, fileType, options) => { this.props.importArticles(formData, fileType, this.props.editLanguage, options) }}
        syncFunc={() => { this.props.syncArticles(this.props.editLanguage)}}
        clearFunc={this.props.clearExportUrls}
        pending={this.props.articles.export_articles_pending}
        scope={'articles'}
        additionalFields={['custom_contents','with_BOM']}
      />
    </React.Fragment> 
  }
}

const mapStateToProps = ({ articles, shop }) => ({
  articles: articles,
  editLanguage: shop.shop.edit_language,
  shopPlan: shop.shop.charge.name,
  shopUrl: shop.shop.url,
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      syncArticles,
      syncArticle,
      syncArticleMetafields,
      createArticleCustomContents,
      deleteArticleCustomContent,
      saveArticles,
      exportArticles,
      importArticles,
      resetErrors,
      clearExportUrls
    },
    dispatch
  )

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(Articles)))